import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Pagination } from "../../../../Components/Pagination";
import { faEye, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DetailModal from "../modals/DetailModal";
import { type } from "jquery";

export default function LoggingHistory() {
  const { proxy, lang } = useSelector((s) => s);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const token = localStorage.getItem("_token");
  const [detail, setDetail] = useState({});

  const [total, setTotal] = useState(0);

  const dataPerPage = 13;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const paginate = (pageNumber) => {
    setSearch((prev) => ({
      ...prev,
      page: pageNumber,
    }));
    setCurrentPage(pageNumber);
    setLoading(true);
  };

  const [search, setSearch] = useState({
    page: 1,
    limit: 13,
  });
  const headers = [
    "#",
    "Tên API",
    "URL",
    "Ngày Tạo",
    "Chế Độ",
    "Trạng Thái",
    "Response ID",
    "Thao Tác",
  ];

  useEffect(() => {
    const queryString = new URLSearchParams(search).toString();
    fetch(proxy() + `/api/SyncData/logs?${queryString}`, {
      headers: {
        Authorization: token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data, total } = res;
        setData(data);
        setTotal(total);
      })
      .finally(() => setLoading(false));
  }, [search]);

  return (
    <>
      <table
        className="table-responsive table-custom design-table w-100"
        style={{
          height: "80vh",
          overflow: "auto",
        }}
      >
        <thead>
          <tr>
            {headers.map((header, index) => (
              <td key={index} style={{ textAlign: "center" }}>
                {header}
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            {[
              { label: "content" },
              { label: "url" },
              { label: "creationDate", isDate: true },
              { label: "mode" },
              { label: "status" },
              { label: "responseId" },
            ].map((item, index) => (
              <td key={index}>
                <input
                  type={item?.isDate ? "date" : "text"}
                  className="form-control"
                  onChange={(e) => {
                    const { value } = e.target;
                    setSearch((prev) => ({
                      ...prev,
                      [item.label]: value.trim(),
                    }));
                  }}
                />
              </td>
            ))}
            <td></td>
          </tr>
          {loading ? (
            <tr>
              <td className="align-center" colSpan={headers.length + 2}>
                <img
                  width="40px"
                  className="mb-1"
                  src="/images/icon/load.gif"
                  alt="Loading..."
                />
              </td>
            </tr>
          ) : data && data.length ? (
            data.map((item, index) => {
              const { content, url, creationDate, mode, status, responseId } =
                item || {};
              return (
                <tr>
                  <td className="align-center">
                    {indexOfFirstData + index + 1}
                  </td>
                  <td>{content}</td>
                  <td
                    style={{
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={url}
                  >
                    {url}
                  </td>
                  <td className="align-center">
                    {moment(creationDate).utc().format("DD/MM/YYYY HH:mm:ss")}
                  </td>
                  <td className="align-center">{mode}</td>
                  <td className="align-center">{status}</td>
                  <td>{responseId}</td>
                  <td className="align-center">
                    <button
                      className="btn btn-success m-0"
                      onClick={() => setDetail(item)}
                      data-toggle="modal"
                      data-target="#detailApiModal"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="align-center" colSpan={headers.length + 2}>
                {lang["not found data"]}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {data && data.length ? (
        <Pagination
          total={total}
          itemsPerPage={dataPerPage}
          currentPage={currentPage}
          paginate={paginate}
          lang={lang}
        />
      ) : null}
      <DetailModal data={detail} />
    </>
  );
}
